<span *ngIf="!!messages && invalid">
  <i class="fa fa-warning text-muted" [title]="tooltipText"></i>
</span>